import React, { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './FormField.module.scss';

export interface IFormFieldProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    labelSlot?: ReactNode;
    errorSlot?: ReactNode;
}

export const FormField: React.FC<IFormFieldProps> = ({ labelSlot, errorSlot, className, children, ...props }) => {
    return (
        <div className={classNames(styles.wrapper, className)} {...props}>
            {labelSlot && <div className={styles.labelSlot}>{labelSlot}</div>}
            {children}
            {errorSlot && <div className={styles.errorSlot}>{errorSlot}</div>}
        </div>
    );
};
